import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { isBrowser } from 'react-device-detect';
import { useOrderStore } from '../../../store/order';
import Cart from '.';
import useIdleTimeout from '../../../context/IdleTimeout';
import { logger } from '../../../utils/logger';

export default function DrawerCart() {
const { openCart, setOpenCart } = useOrderStore();
const { idleTimer, setIsIdle } = useIdleTimeout({ idleTime: 60, disableIdleTimer: false });

const closeCart =()=> { 
  	// if (!isBrowser) {
	//   if (window.ReactNativeWebView !== undefined) {
	// 	window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
	//   } else if(window.Android !== undefined){
	// 	window.Android.postMessage(JSON.stringify({'type':'play'}));
	//   }
	// }
	setOpenCart(false);
	setIsIdle(false);
	idleTimer.reset();
	logger.debug('closeCart')
}

  return (
    <div>
			<React.Fragment key={'right'}>
					<Drawer
						transitionDuration={100}
						anchor={'right'}
						open={openCart}
						onClose={closeCart}
					>
						<Cart/>
					</Drawer>
			</React.Fragment>
    </div>
  );
}
